'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Category {
  id: string;
  label: string;
  icon: string;
  count: number;
}

interface CategoryFilterProps {
  categories: Category[];
  activeCategory: string;
  onCategoryChange: (categoryId: string) => void;
}

const CategoryFilter: React.FC<CategoryFilterProps> = ({ 
  categories, 
  activeCategory, 
  onCategoryChange 
}) => {
  return (
    <div className="bg-card rounded-lg shadow-subtle p-4 mb-8">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground">Filter by Category</h3>
        {activeCategory !== 'all' && (
          <button
            onClick={() => onCategoryChange('all')}
            className="text-sm text-primary hover:text-primary/80 transition-colors duration-200"
          >
            Clear Filter
          </button>
        )}
      </div>
      
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategoryChange(category.id)}
            className={`flex flex-col md:flex-row items-center p-4 rounded-lg transition-all duration-300 ${
              activeCategory === category.id
                ? 'bg-primary text-primary-foreground shadow-cta'
                : 'bg-muted hover:bg-muted/80 text-foreground'
            }`}
          >
            <Icon 
              name={category.icon as any} 
              size={24} 
            />
            <span className="text-sm font-medium text-center mx-auto">{category.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;